module.exports = __webpack_public_path__ + "img/04—01—01—Settings.01c584e3.jpg";